module.exports = __webpack_public_path__ + "img/geod_1.bfe45f77.jpg";